module.exports = __webpack_public_path__ + "static/media/bmscell.7514bfe0.jpeg";